import { render, staticRenderFns } from "./DataScreenCategoryForm.vue?vue&type=template&id=d61e6546"
import script from "./DataScreenCategoryForm.vue?vue&type=script&lang=js"
export * from "./DataScreenCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d61e6546')) {
      api.createRecord('d61e6546', component.options)
    } else {
      api.reload('d61e6546', component.options)
    }
    module.hot.accept("./DataScreenCategoryForm.vue?vue&type=template&id=d61e6546", function () {
      api.rerender('d61e6546', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/datav/DataScreenCategoryForm.vue"
export default component.exports